import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-248e4b53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "text-h6 text-md-h5 mb-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ejército:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Puntos de torneo:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Victorias:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Empates:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Derrotas:", -1))
const _hoisted_8 = {
  key: 0,
  class: "w-100"
}
const _hoisted_9 = {
  key: 0,
  class: "image-container"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 1,
  class: "px-4 py-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No tienes partidas en torneos", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "w-100"
}
const _hoisted_16 = { class: "matches-list" }
const _hoisted_17 = {
  key: 1,
  class: "px-4 py-2"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No tienes partidas en torneos", -1))
const _hoisted_19 = [
  _hoisted_18
]

import { Clasificacion } from "@/interfaces/Live";
import { ViewPartidaTorneoDTO } from "@/interfaces/Partidas";
import { getPartidasTorneoByUsuarioAsync } from "@/services/PartidaTorneoService";
import { ref, watch, onMounted } from "vue";

import CardPartidaTorneo from "../PartidasTorneo/CardPartidaTorneo.vue";
import { getlistaTorneo } from "@/services/ListasService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDetalleActuacionTorneo',
  props: {
    show: { type: Boolean },
    jugador: {}
  },
  emits: ["update:show"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const internalShow = ref<boolean>(props.show);
const loading = ref<boolean>(true);
const data = ref<Clasificacion>();
const matches = ref<ViewPartidaTorneoDTO[]>([]);
const listaBase64 = ref<string>();
const isLoadingMatches = ref<boolean>(false);
const isLoadingLista = ref<boolean>(false);

watch(
  () => props.show,
  (val) => (internalShow.value = val)
);

watch(internalShow, (visible) => {
  if (visible) {
    loadData();
  }
});

const loadData = async () => {
  loading.value = true;
  try {
    data.value = props.jugador;
    isLoadingMatches.value = true;
    isLoadingLista.value = true;

    const response = await getPartidasTorneoByUsuarioAsync(
      props.jugador.idTorneo,
      props.jugador.idUsuario
    );

    matches.value = response.data;

    const responseLista = await getlistaTorneo({
      idTorneo: props.jugador.idTorneo,
      idUsuario: props.jugador.idUsuario,
    });

    listaBase64.value = responseLista.data.listaData;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
    isLoadingMatches.value = false;
    isLoadingLista.value = false;
  }
};

const close = () => {
  internalShow.value = false;
  emit("update:show", false);
};

onMounted(() => {
  if (internalShow.value) {
    loadData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: internalShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalShow).value = $event)),
    "max-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
            default: _withCtx(() => [
              _createTextVNode(" Resumen actuación "),
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (loading.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    color: "primary",
                    class: "d-block mx-auto my-6"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_card, { class: "pa-4 mb-4 player-info-card" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { dense: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "text-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", _hoisted_2, _toDisplayString(data.value?.nick), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _hoisted_3,
                                _createTextVNode(" " + _toDisplayString(data.value?.ejercito), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _hoisted_4,
                                _createTextVNode(" " + _toDisplayString(data.value?.puntosTorneo), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "4"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5,
                                _createTextVNode(" " + _toDisplayString(data.value?.victorias), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "4"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6,
                                _createTextVNode(" " + _toDisplayString(data.value?.empates), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "4"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7,
                                _createTextVNode(" " + _toDisplayString(data.value?.derrotas), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "flex-column align-start" }, {
            default: _withCtx(() => [
              (!isLoadingLista.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0" }, {
                      default: _withCtx(() => [
                        (listaBase64.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("img", {
                                src: listaBase64.value,
                                alt: "Lista",
                                style: {"max-width":"100%","height":"auto"}
                              }, null, 8, _hoisted_10)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_11, "No hay lista disponible"))
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "flex-column align-start" }, {
            default: _withCtx(() => [
              (!isLoadingMatches.value && matches.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matches.value, (match) => {
                            return (_openBlock(), _createBlock(CardPartidaTorneo, {
                              key: match.idPartidaTorneo,
                              idUsuario: props.jugador.idUsuario,
                              match: match,
                              class: "mb-4"
                            }, null, 8, ["idUsuario", "match"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                text: "",
                onClick: close,
                variant: "tonal",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cerrar")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})